import { AlgorithmJoinsMutationDtoSchema } from './AlgorithmJoinsMutationDtoSchema';
import { AlgorithmJoinsFormDataSchema } from './formData/AlgorithmJoinsFormDataSchema';
import {
  AlgorithmJoinsFormDataType,
  AlgorithmJoinsMutationDtoType,
  AlgorithmJoinsValidFormDataType,
} from './types';
import { AlgorithmJoinsValidFormDataSchema } from './validFormData/AlgorithmJoinsValidFormDataSchema';

export class AlgorithmJoinsSchema {
  static parseFormData<Dto>(data: Dto): AlgorithmJoinsFormDataType {
    return AlgorithmJoinsFormDataSchema.parse(data);
  }

  static parseMutationDto<
    ValidFormData extends Partial<AlgorithmJoinsValidFormDataType>
  >(validFormData: ValidFormData): AlgorithmJoinsMutationDtoType {
    return AlgorithmJoinsMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = AlgorithmJoinsValidFormDataSchema;
}
